/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAufgabeVerlaufListResponseDto } from '../../models/lexplus-aufgabe-verlauf-list-response-dto';
import { LexplusVerlaufFilterEnum } from '../../models/lexplus-verlauf-filter-enum';

export interface AufgabenControllerFindVerlaufV1$Params {
  id: number;
  filter?: LexplusVerlaufFilterEnum;
  page?: number;
  limit?: number;
}

export function aufgabenControllerFindVerlaufV1(http: HttpClient, rootUrl: string, params: AufgabenControllerFindVerlaufV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAufgabeVerlaufListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerFindVerlaufV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('filter', params.filter, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAufgabeVerlaufListResponseDto>;
    })
  );
}

aufgabenControllerFindVerlaufV1.PATH = '/v1/aufgaben/{id}/verlauf';
